import React, { useEffect, useState } from "react";
import { Search, SearchIconWrapper, StyledInputBase } from "./style";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { GetAllCompainesListThunk } from "app/store/slice/company-slice";
import { GetAllAccountsListThunk } from "app/store/slice/account-slice";
import { GetAllUsersListThunk } from "app/store/slice/user-slice";
import { GetAllRolesListThunk } from "app/store/slice/role-slice";
import { GetAllAdvertisersListThunk } from "app/store/slice/advertiser-slice";
import { GetAllPublishersListThunk } from "app/store/slice/publisher-slice";
import { GetAllCampaignsListThunk } from "app/store/slice/campaign-slice";
import { GetAllThemesListThunk } from "app/store/slice/theme-slice";

import { dispatch } from "app/store/store";
import { Box, Stack } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { GetAllSupplyListThunk } from "app/store/slice/supply-slice";
import { GetAudienceSegmentsListThunk } from "app/store/slice/audience-management-slice";
import { useSelector } from "react-redux";
import { GetAllSupplyDealsListThunk } from "app/store/slice/supply-deal-slice";
import { GetAllTargetingGroupsListThunk } from "app/store/slice/targeting-groups-slice";
import { GetAllDemandPartnersListThunk } from "app/store/slice/demand-partner-slice";
import { GetAllPrivateMarketPlaceListThunk } from "app/store/slice/private-market-place-slice";
import cloneDeep from "lodash.clonedeep";
import { MasterAllowProvidersListInManageSegments } from "app/utils/constants/data";
import { getUniqueAudienceProviders } from "app/utils/utils";

const SearchGlobal = ({ sx, plh, screen }) => {
  const { authUserData, globalAccountsList } = useSelector(
    (state) => state.CommonReducer
  );
  const [searchValue, setSearchValue] = useState("");
  const { campaignFilters } = useSelector((state) => state.CampaignReducer);
  const { targetingGroupFilters } = useSelector(
    (state) => state.TargetingGroupReducer
  );

  const { accountFilters } = useSelector((state) => state.AccountReducer);

  const onSearch = (seachTxt) => {
    if (screen == "managecompanies") {
      dispatch(
        GetAllCompainesListThunk({
          search: seachTxt,
          authUserData: authUserData,
        })
      );
    } else if (screen == "manageaccounts") {
      dispatch(
        GetAllAccountsListThunk({
          search: seachTxt,
          authUserData: authUserData,
          accountFilters: accountFilters,
        })
      );
    } else if (screen == "manageusers") {
      dispatch(
        GetAllUsersListThunk({ search: seachTxt, authUserData: authUserData })
      );
    } else if (screen == "manageroles") {
      dispatch(
        GetAllRolesListThunk({ search: seachTxt, authUserData: authUserData })
      );
    } else if (screen == "manageadvertisers") {
      dispatch(
        GetAllAdvertisersListThunk({
          search: seachTxt,
          authUserData: authUserData,
        })
      );
    } else if (screen == "managepublishers") {
      dispatch(
        GetAllPublishersListThunk({
          search: seachTxt,
          authUserData: authUserData,
        })
      );
    } else if (screen == "campaigns") {
      dispatch(
        GetAllCampaignsListThunk({
          search: seachTxt,
          authUserData: authUserData,
          campaignFilters: campaignFilters,
        })
      );
    } else if (screen == "managethemes") {
      dispatch(
        GetAllThemesListThunk({ search: seachTxt, authUserData: authUserData })
      );
    } else if (screen == "supplyanalysis") {
      dispatch(
        GetAllSupplyListThunk({ search: seachTxt, authUserData: authUserData })
      );
    } else if (screen == "segments") {
      let finalProvidersArr = [];
      let mlps = cloneDeep(MasterAllowProvidersListInManageSegments);
      if (authUserData?.is_sys_admin != "1") {
        let userAccessAudienceProviders =
          getUniqueAudienceProviders(globalAccountsList);
        for (let k = 0; k < mlps.length; k++) {
          if (userAccessAudienceProviders.includes(mlps[k].value)) {
            finalProvidersArr.push(mlps[k].value);
          }
        }
      }
      dispatch(
        GetAudienceSegmentsListThunk({
          search: seachTxt,
          authUserData: authUserData,
          providers: finalProvidersArr,
        })
      );
    } else if (screen == "supplydeals") {
      dispatch(
        GetAllSupplyDealsListThunk({
          search: seachTxt,
          authUserData: authUserData,
        })
      );
    } else if (screen == "targetinggroups") {
      dispatch(
        GetAllTargetingGroupsListThunk({
          search: seachTxt,
          authUserData: authUserData,
          targetingGroupFilters: targetingGroupFilters,
        })
      );
    } else if (screen == "managedemandpartners") {
      dispatch(
        GetAllDemandPartnersListThunk({
          search: seachTxt,
          authUserData: authUserData,
        })
      );
    } else if (screen == "manageprivatemarketplace") {
      dispatch(
        GetAllPrivateMarketPlaceListThunk({
          search: seachTxt,
          authUserData: authUserData,
        })
      );
    }
  };

  return (
    <Search sx={sx}>
      {/* <SearchIconWrapper onClick={onSearch}>
        <SearchIcon />
      </SearchIconWrapper> */}
      <StyledInputBase
        placeholder={plh}
        inputProps={{ "aria-label": "search" }}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        value={searchValue}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (searchValue != "") {
              onSearch(searchValue);
            }
          }
        }}
        // onBlur={() => {
        //   onSearch(searchValue);
        // }}
        endAdornment={
          <>
            <SearchIcon
              sx={{ mr: searchValue != "" ? 1 : 2, cursor: "pointer" }}
              onClick={() => {
                if (searchValue != "") {
                  onSearch(searchValue);
                }
              }}
            />
            {searchValue != "" && (
              <CloseIcon
                sx={{ mr: 1, cursor: "pointer" }}
                onClick={() => {
                  setSearchValue("");
                  onSearch("");
                }}
              />
            )}
          </>
        }
      />
      {/* <SearchIconWrapper onClick={onSearch}>
        <SearchIcon />
      </SearchIconWrapper> */}
    </Search>
  );
};

export default SearchGlobal;
